const currencySymbols = {
  nok: "kr",
  usd: "$",
  gbp: "£",
  cad: "C$",
  chf: "CHF",
  nzd: "NZ$",
  aud: "A$",
  aed: "د.إ",
  eur: "€"
};

const allowedCountries = [
  "NO",
  "US",
  "IM",
  "CA",
  "CH",
  "NZ",
  "AU",
  "AE",
  "NL",
  "GB",
  "IE",
  "LU"
];

export { currencySymbols, allowedCountries };
